export const companyOptions = [
  { id: "شرکت سهامی عام", title: "شرکت سهامی عام" },
  { id: "شرکت سهامی خاص", title: "شرکت سهامی خاص" },
  { id: "شرکت با مسئولیت محدود", title: "شرکت با مسئولیت محدود" },
  { id: "شرکت تضامنی", title: "شرکت تضامنی" },
  { id: "شرکت مختلط غیر سهامی", title: "شرکت مختلط غیر سهامی" },
  { id: "شرکت مختلط سهامی", title: "شرکت مختلط سهامی" },
  { id: "شرکت تعاونی تولید و مصرف", title: "شرکت تعاونی تولید و مصرف" },
];
